import { gql } from '@apollo/client';

export const GET_CART = gql`
  query CART_SERVICE_V2_getCart($id: ID!) {
    getCart(id: $id) {
      id
      groupId
      cartName
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      rateSegment
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

export const CREATE_CART = gql`
  mutation CART_SERVICE_V2_createCart(
    $sponsorId: String
    $groupId: String
    $cartSource: CartSource
    $browsingCriteria: Map
    $rateSegment: RateSegment
  ) {
    createCart(
      sponsorId: $sponsorId
      groupId: $groupId
      cartSource: $cartSource
      browsingCriteria: $browsingCriteria
      rateSegment: $rateSegment
    ) {
      id
      groupId
      cartName
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      rateSegment
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

export const ADD_PORTFOLIO_TO_CART = gql`
  mutation CART_SERVICE_V2_addPortfolioConfigToCart(
    $sponsorId: String
    $portfolioConfigRequest: PortfolioConfigRequest
  ) {
    addPortfolioConfigToCart(sponsorId: $sponsorId, portfolioConfigRequest: $portfolioConfigRequest) {
      id
      groupId
      cartName
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      rateSegment
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

export const REMOVE_PORTFOLIO_FROM_CART = gql`
  mutation CART_SERVICE_V2_removePortfolioConfigFromCart(
    $cartId: ID!
    $portfolioId: String
    $removeLastActiveBC: Boolean
  ) {
    removePortfolioConfigFromCart(cartId: $cartId, portfolioId: $portfolioId, removeLastActiveBC: $removeLastActiveBC) {
      id
      groupId
      lastUpdateBrowsingCriteria
      rateSegment
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

export const REMOVE_BC_BY_INDEX = gql`
  mutation CART_SERVICE_V2_removeBCByIndex($cartId: ID!, $portfolioId: String, $index: Int) {
    removeBCByIndex(cartId: $cartId, portfolioId: $portfolioId, index: $index) {
      id
      groupId
      cartName
      creationDateTime
      lastUpdateBrowsingCriteria
      rateSegment
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

export const UPDATE_BC = gql`
  mutation CART_SERVICE_V2_updateLastBC($cartId: ID!, $browsingCriteria: Map, $sponsorId: String) {
    updateLastBC(cartId: $cartId, browsingCriteria: $browsingCriteria, sponsorId: $sponsorId) {
      id
      groupId
      lastUpdateBrowsingCriteria
      lastUpdateTime
      cartName
      creationDateTime
      rateSegment
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

export const SAVE_PROPOSAL = gql`
  mutation CART_SERVICE_V2_saveProposal($cartId: ID!, $cartName: String) {
    saveProposal(cartId: $cartId, cartName: $cartName) {
      id
      groupId
      cartName
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      rateSegment
      premiumCostAnswers
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

export const COPY_CART = gql`
  mutation CART_SERVICE_V2_CopyCart($id: ID!) {
    copyCart(id: $id) {
      id
      cartName
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      rateSegment
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;
export const SAVE_QUOTE = gql`
  mutation CART_SERVICE_V2_saveQuote(
    $cartId: ID!
    $email: String!
    $groupId: String!
    $sponsorId: String!
    $message: String
    $name: String!
  ) {
    saveQuote(
      cartId: $cartId
      email: $email
      groupId: $groupId
      sponsorId: $sponsorId
      message: $message
      name: $name
    ) {
      id
      cartName
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      rateSegment
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;

export const UPDATE_RATE_SEGMENT = gql`
  mutation CART_SERVICE_V2_updateRateSegment($cartId: ID!, $rateSegment: RateSegment!) {
    updateRateSegment(cartId: $cartId, rateSegment: $rateSegment) {
      id
      groupId
      cartName
      creationDateTime
      lastUpdateBrowsingCriteria
      lastUpdateTime
      rateSegment
      cartItems {
        portfolioId
        portfolioName
        productLineId
        browsingCriteria
        selectedIndex
        confirmed
        equalsWithLastUpdateBCIndex
      }
    }
  }
`;
